export type DashboardDetailsType = {
  total: {
    referrals: number;
    depositTot: number;
    profitTot: number;
    withdrawalTot: number;
    current: number;
  };
  adminTotal: {
    depositTot: number;
    profitTot: number;
    withdrawalTot: number;
    current: number;
    referral: number;
  };
  loading: boolean;
};

export const initialState: DashboardDetailsType = {
  total: {
    referrals: 0,
    current: 0,
    depositTot: 0,
    profitTot: 0,
    withdrawalTot: 0,
  },
  adminTotal: {
    current: 0,
    depositTot: 0,
    profitTot: 0,
    withdrawalTot: 0,
    referral: 0,
  },
  loading: false,
};
